import axios from 'axios';

export default class Rest {

  public static async POST(resource: string, body: any) {
    return await axios.post(`${Rest.URI}${resource}`, null, Rest.axiosParams(body));
  }

  public static async POSTComplete(resource: string, body: any, headers:any) {
    return await axios.post(`${Rest.URI}${resource}`, body, Rest.axiosHeader(headers));
  }

  public static async GraphqlPOST(body: any) {
    return await axios.post(`${process.env.GRAPHQL}`, body, Rest.axiosParams(body));
  }

  public static async GET(resource: string, body: any) {
    if(body == null || body === undefined) {
      body = '';
    } else {
      body = `/${body}`;
    }
    return await fetch(`${Rest.URI}${resource}${body}`, Rest.params('GET'));
  }

  public static async DELETE(resource: string, id:number) {
    return await axios.delete(`${Rest.URI}${resource}/${id}`, Rest.axiosParams(null));
  }

  private static URI = `${process.env.API}`;
  private static params(method: string) {
    const token = `${'Bearer '}${sessionStorage.getItem('token')}`;
    return {
      headers: new Headers({
        authorization: token
      }),
      method
    }
  }
  private static axiosParams(params: any) {
    const token = `${'Bearer '}${sessionStorage.getItem('token')}`;
    return {
      headers: {
        Authorization: token,
      },
      params
    }
  }

  private static axiosHeader(header: any) {
    const token = `${'Bearer '}${sessionStorage.getItem('token')}`;
    const headersObj:any = header;
    headersObj.Authorization = token
    return {
      headers: headersObj
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/Rest.tsx